exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td.exist_error[data-v-18d24f44]{border:1px solid red}", ""]);

// exports
